// TODO: Add proper typing for patient
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isHybridPatient(patient: any) {
  return patient.ce_structure === "hybrid";
}
